import { BiPencil } from "react-icons/bi";
import { PaddedIcon } from "../../components/ui/button/Icon";
import Workspace from "../../components/workspace";

const Offering = ({ offering, formModal, setSelected }) => {
   return (
      <Workspace.ItemWrapper
         onClick={() => {
            setSelected(offering);
            formModal.onOpen();
         }}>
         <div className="flex items-center px-4 py-5 gap-x-4 md:gap-x-6">
            <input type="checkbox" onClick={(e) => e.stopPropagation()} />
            <div className="grid gap-x-3 grid-cols-12 w-full items-center">
               <div className="col-span-5 overflow-hidden overflow-ellipsis">
                  <p className="font-bold">{`${offering.offeringDate} | ${offering.offeringType}`}</p>
                  <small className="">{offering.sourceCode}</small> | <small className=" col-1">{offering.currency}</small>
               </div>

               <p className="col-span-2">{offering.amount}</p>
               <p className="col-span-1 text-xs">{offering.branchCode}</p>
               <p className="col-span-2">
                  {offering.giverFirstName ? `${offering.giverFirstName} ${offering.giverLastName}` : null}
               </p>

               <Workspace.ItemActionsWrapper>
                  <PaddedIcon variant="primary">
                     <BiPencil className=" text-xl" />
                  </PaddedIcon>
               </Workspace.ItemActionsWrapper>
            </div>
         </div>
      </Workspace.ItemWrapper>
   );
};

export default Offering;
